import Card from './Card.jsx';
import '../assets/css/src/cards.css';

export default function Cards({ data = [] }) {
  return (
    <section className="cards">
      {data.map((card) => (
        <Card key={card.id} {...card} />
      ))}
    </section>
  );
}
